'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareSecurity = function HardwareSecurity(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' })
  );
};
HardwareSecurity = (0, _pure2.default)(HardwareSecurity);
HardwareSecurity.displayName = 'HardwareSecurity';

exports.default = HardwareSecurity;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/hardware/security.js
 ** module id = 1529
 ** module chunks = 0
 **/